
const NOOP = () => {
    // pass
};

export default function observe<T extends Element>(element: T, onIntersect: (element: T) => void, options?: IntersectionObserverInit) {
    if (!window.IntersectionObserver) {
        onIntersect(element);
        return NOOP;
    }

    const context: {intersectionObserver?: IntersectionObserver} = {};

    context.intersectionObserver = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting || entry.isIntersecting === undefined) {
            onIntersect(element);
        }
    }, options);

    context.intersectionObserver.observe(element);

    return () => context.intersectionObserver!.unobserve(element);
}
